"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated @deprecated use {@link DialogManager} and {@link DialogContent} instead
 */
class CaptionedPopup {
    static getCaptionedPopupHtml(style, caption, contentHtml) {
        return ` <div>${contentHtml}</div>`;
        /*
        return `<div class="popup-window">
      <div class="popup-content titled ${style}">
        <div class="content title">
          <button  class="close"></button>
          <h2 class="caption">${caption}</h2>
        </div>
        <div>${contentHtml}</div>
    </div>`;

 */
    }
}
exports.default = CaptionedPopup;
//# sourceMappingURL=CaptionedPopup.js.map